import { createContext, ReactNode, useContext, useState } from 'react'

import { FormBuilderConfig } from './types/form-builder.types'

type FieldContextType = {
  value: Record<string, string | boolean>
  setValue: (value: FormBuilderConfig) => void
}

type FormBuilderContextProps = {
  children: ReactNode
}

const FormBuilderContext = createContext<any>(undefined)

export const FormBuilderContextProvider = ({ children }: FormBuilderContextProps) => {
  const [value, setValue] = useState<any>('')

  return <FormBuilderContext.Provider value={{ value, setValue }}>{children}</FormBuilderContext.Provider>
}

export const useFBField = (): FieldContextType => {
  const context = useContext(FormBuilderContext)
  if (!context) {
    throw new Error('useField must be used within a FieldProvider')
  }

  return context
}
